      (function() {
      // Evita esecuzioni multiple
      if (window.__InboxChatLabelObserver) return;
      window.__InboxChatLabelObserver = true;

    // Funzione che cerca il bottone dentro lo shadowRoot
      function labelChatButton(chatEl) {
        try {
          const root = chatEl.shadowRoot;
          if (!root) return; // ancora non inizializzato

          const btn = root.querySelector(
            'button.chat-toggle'
          );
          if (btn && !btn.hasAttribute('aria-label')) {
            btn.setAttribute('aria-label', 'chat assistenza');
            btn.setAttribute('title', 'chat assistenza');
            console.log('[inbox-a11y] Aggiunto aria-label="chat" al pulsante Inbox');
          }
        } catch (e) {
          console.warn('[inbox-a11y] Errore durante la scansione del shadowRoot:', e);
        }
      }


  // Osserva il documento per l’aggiunta del tag inbox-online-store-chat
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && node.tagName.toLowerCase() === 'inbox-online-store-chat') {
          // tenta subito
          labelChatButton(node);

          // osserva anche cambiamenti dentro lo shadowRoot (quando viene popolato)
          const tryShadow = () => {
            console.log(node.shadowRoot)
            if (node.shadowRoot) {
              const innerObs = new MutationObserver(() => labelChatButton(node));
              innerObs.observe(node.shadowRoot, { childList: true, subtree: true });
              labelChatButton(node);
            } else {
              // se lo shadowRoot non esiste ancora, riprova dopo un po’
              setTimeout(tryShadow, 300);
            }
          };
          tryShadow();
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
      console.log('[inbox-a11y] Attivo observer su <inbox-online-store-chat>');
    })();